import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';
import { CoreWidgetsModule } from '../../widgets/core.widgets.module';
import { CoreFiltersModule } from '../../core/core.filters.module';
import { NvD3Module } from '../../widgets/nvd3';
import { SCM_STATES } from './scm.routes.config';

import { DiffAggregateService } from './services/scm.diff.service';
import { ScmService } from './services/scm.service';
import { ScmLinkService } from './services/scm.link.service';
import { ScmChartService } from './services/scm.chart.service';
import { ScmResolvesService } from './scm-resolves.service';
import { BranchTagComponent } from './branch-tag/scm.branch-tag.component';
import { ScmHeaderComponent } from './header/scm.header.component';
import { ScmCommitListComponent } from './commits/scm.commits.component';
import { ScmMergeComponent } from './merge/scm.merge.component';
import { ScmBrowseComponent } from './browse/scm.browse.component';
import { ScmCommitDiffComponent } from './commit/scm.commit.component';
import { ScmTreeComponent } from './tree/scm.tree.component';
import { ScmFileViewComponent } from './file/scm.file.component';
import { ScmHomeComponent } from './home/scm.home.component';
import { ScmHomeGitComponent } from './home/scm.home.git.component';
import { ScmHomeSvnComponent } from './home/scm.home.svn.component';
import { ScmHomeCvsComponent } from './home/scm.home.cvs.component';

@NgModule({
    imports: [
      CommonModule,
      FormsModule,
      CoreWidgetsModule,
      CoreFiltersModule,
      NvD3Module,
      UIRouterModule.forChild({ states: SCM_STATES })
    ],
    providers: [
        DiffAggregateService,
        ScmService,
        ScmLinkService,
        ScmChartService,
        ScmResolvesService
    ],
    declarations: [
        BranchTagComponent,
        ScmHeaderComponent,
        ScmCommitListComponent,
        ScmMergeComponent,
        ScmBrowseComponent,
        ScmCommitDiffComponent,
        ScmTreeComponent,
        ScmFileViewComponent,
        ScmHomeComponent,
        ScmHomeGitComponent,
        ScmHomeSvnComponent,
        ScmHomeCvsComponent
    ],
    exports: [
        BranchTagComponent,
        ScmHeaderComponent,
        ScmCommitListComponent,
        ScmMergeComponent,
        ScmBrowseComponent,
        ScmCommitDiffComponent,
        ScmTreeComponent,
        ScmFileViewComponent,
        ScmHomeComponent,
        ScmHomeGitComponent,
        ScmHomeSvnComponent,
        ScmHomeCvsComponent
    ],
})
export class ScmModule { }
